import FormTextField, { FormTextFieldProps } from './FormTextField';

type DateFieldProps = Omit<FormTextFieldProps, 'type' | 'InputLabelProps'>;

export default function DateField(props: DateFieldProps) {
  return (
    <FormTextField
      {...props}
      type="date"
      InputLabelProps={{ shrink: true }}
    />
  );
}
